import { useState, useEffect } from "react";

export default function SaveSessionButton({
  activeComponentIndex,
  generatedItems,
  project,
  itemOpenIndex,
  activeUnitIndex,
  saveUserBehaviour,
}) {
  return null;
  const [isLoading, setIsLoading] = useState(false);

  // Add the animation keyframes to the document once when component mounts
  useEffect(() => {
    const styleElement = document.createElement("style");
    styleElement.textContent = `
      @keyframes dotBounce {
        0%, 80%, 100% { transform: scale(0); } 
        40% { transform: scale(1.0); }
      }
    `;
    document.head.appendChild(styleElement);

    return () => {
      document.head.removeChild(styleElement);
    };
  }, []);

  // Only show button if we have an active component and generated items
  if (
    activeComponentIndex === undefined ||
    Object.keys(generatedItems).length === 0
  ) {
    return null;
  }

  const handleSaveClick = async () => {
    setIsLoading(true);

    try {
      const modifiedItems =
        project?.rooms[itemOpenIndex].Units[activeUnitIndex].Components[
          activeComponentIndex
        ];

      // Execute the save function
      await saveUserBehaviour(generatedItems, modifiedItems);

      // Optional: Add a slight delay to ensure users see the loading state
      setTimeout(() => {
        setIsLoading(false);
      }, 800);
    } catch (error) {
      console.error("Error saving session:", error);
      setIsLoading(false);
    }
  };

  const dotStyle = (delay) => ({
    display: "inline-block",
    width: "4px",
    height: "4px",
    borderRadius: "50%",
    backgroundColor: "#353535",
    margin: "0 2px",
    animation: "dotBounce 1.4s infinite ease-in-out both",
    animationDelay: delay,
  });

  return (
    <div style={{ marginLeft: "auto" }}>
      <button
        style={{
          padding: "8px 16px",
          fontSize: "14px",
          fontWeight: 600,
          borderRadius: "8px",
          backgroundColor: isLoading ? "#f0d78a" : "#fae291",
          color: "#353535",
          border: "none",
          cursor: isLoading ? "default" : "pointer",
          transition: "background-color 0.3s, box-shadow 0.3s",
          position: "relative",
          width: isLoading ? "120px" : "auto",
          overflow: "hidden",
        }}
        onMouseOver={(e) => {
          if (!isLoading) {
            e.target.style.backgroundColor = "#fdd34d";
            e.target.style.boxShadow = "0 4px 8px rgba(0, 105, 217, 0.4)";
          }
        }}
        onMouseOut={(e) => {
          if (!isLoading) {
            e.target.style.backgroundColor = "#fae291";
            e.target.style.boxShadow = "0 2px 6px rgba(0, 123, 255, 0.3)";
          }
        }}
        onClick={isLoading ? null : handleSaveClick}
        disabled={isLoading}
      >
        {isLoading ? (
          <>
            <span>Saving</span>
            <span
              style={{
                position: "absolute",
                right: "15px",
                display: "inline-block",
              }}
            >
              <span style={dotStyle("0s")}></span>
              <span style={dotStyle("0.2s")}></span>
              <span style={dotStyle("0.4s")}></span>
            </span>
          </>
        ) : (
          "Save Session"
        )}
      </button>
    </div>
  );
}
